import { useEffect, useState } from 'react';

import type { AiDocumentMetadata } from './types';

type UseDocumentPreviewMetadataSectionOptions = {
  metadata: AiDocumentMetadata | undefined;
  resetWhen: unknown;
};

/** Collapsible document-metadata state for the preview panel header. */
export function useDocumentPreviewMetadataSection({
  metadata,
  resetWhen,
}: UseDocumentPreviewMetadataSectionOptions) {
  const [isOpen, setIsOpen] = useState(false);
  const entries = (metadata ?? []).filter((entry) => entry.value.trim() !== '');

  useEffect(() => {
    if (resetWhen) {
      setIsOpen(false);
    }
  }, [resetWhen]);

  return {
    entries,
    hasEntries: entries.length > 0,
    isOpen,
    toggle: () => setIsOpen((open) => !open),
  };
}
